<template>
    <a v-if="href" :href="href" class="product-rating product-rating-link">
        <div class="back-stars">
            <i class="las la-star"></i>
            <i class="las la-star"></i>
            <i class="las la-star"></i>
            <i class="las la-star"></i>
            <i class="las la-star"></i>

            <div class="front-stars" :style="{ width: displayRatingPercent + '%' }">
                <i class="las la-star"></i>
                <i class="las la-star"></i>
                <i class="las la-star"></i>
                <i class="las la-star"></i>
                <i class="las la-star"></i>
            </div>
        </div>

        <span class="rating-count">{{ displayReviewCount || 0 }} Reviews</span>
    </a>
    <div v-else class="product-rating">
        <div class="back-stars">
            <i class="las la-star"></i>
            <i class="las la-star"></i>
            <i class="las la-star"></i>
            <i class="las la-star"></i>
            <i class="las la-star"></i>

            <div class="front-stars" :style="{ width: displayRatingPercent + '%' }">
                <i class="las la-star"></i>
                <i class="las la-star"></i>
                <i class="las la-star"></i>
                <i class="las la-star"></i>
                <i class="las la-star"></i>
            </div>
        </div>

        <span class="rating-count">{{ displayReviewCount || 0 }} Reviews</span>
    </div>
</template>

<script>
    import YotpoRatingService from '../services/YotpoRatingService';

    export default {
        props: ['ratingPercent', 'reviewCount', 'productId', 'sku', 'href'],

        data() {
            return {
                yotpoRating: null
            };
        },

        computed: {
            displayRatingPercent() {
                if (this.yotpoRating) {
                    return (this.yotpoRating.averageScore / 5) * 100;
                }
                return 0;
            },

            displayReviewCount() {
                if (this.yotpoRating) {
                    return this.yotpoRating.totalReviews;
                }
                return 0;
            },
        },

        mounted() {
            if (YotpoRatingService.isEnabled() && this.sku) {
                var self = this;
                YotpoRatingService.fetchRating(this.sku).then(function (result) {
                    if (result) {
                        self.yotpoRating = result;
                    }
                });
            }
        },
    };
</script>

<style scoped>
    .product-rating-link,
    .product-rating-link:hover,
    .product-rating-link:focus {
        color: inherit;
        text-decoration: none;
        cursor: pointer;
    }
</style>
